import type { PreviewProvider } from './provider'

export const preview: PreviewProvider = {
  enabled: false,
  get() {
    throw new Error('预览数据在 integration/production 构建中不可用。')
  },
}
